export default {
  // Page title
  title: 'Activity List',
  // Top actions
  addActivity: 'Add Activity',
  sortLevelTooltip:
    'Priority Note: Higher numbers indicate higher priority. If a QR code is involved in multiple activities, consumers will enter the activity with higher priority.',
  // Search
  activityName: 'Activity Name',
  activityNamePlaceholder: 'Enter activity name',
  activityId: 'Activity ID',
  activityIdPlaceholder: 'Enter activity ID',
  activityNo: 'Activity No.',
  activityNoPlaceholder: 'Enter activity No.',
  activityStatus: 'Activity Status',
  activityStatusPlaceholder: 'All',
  codeSn: 'QR Code',
  codeSnPlaceholder: 'Enter QR code',
  search: 'Search',
  reset: 'Reset',
  // Status
  statusAll: 'All',
  statusNotStarted: 'Not Started',
  statusActive: 'Active',
  statusEnded: 'Ended',
  statusDisabled: 'Disabled',
  // Table columns
  colActivityId: 'Activity ID',
  colActivityCode: 'Activity Code',
  colActivityName: 'Activity Name',
  colActivityTime: 'Activity Time',
  colStatus: 'Status',
  colSortLevel: 'Priority',
  colRemark: 'Remark',
  colCreateTime: 'Create Time',
  colAction: 'Action',
  // Actions
  actions: 'Actions',
  detail: 'Detail',
  edit: 'Edit',
  disable: 'Disable',
  enable: 'Enable',
  delete: 'Delete',
  // Time range
  timeRangeSep: 'to',
  // Sort edit
  sortLevelPlaceholder: 'Enter sort level',
  // Confirm modal
  confirmDeleteTitle: 'Confirm Delete',
  confirmDeleteContent: 'Are you sure to delete this activity? This action cannot be undone.',
  confirmToggleTitle: 'Confirm Action',
  confirmDisableContent: 'Are you sure to disable this activity?',
  confirmEnableContent: 'Are you sure to enable this activity?',
  // Empty state
  emptyText: 'No activity data',
};
